module.exports = __webpack_public_path__ + "img/156_thumbnail.8560089b.jpg";